// extracted by mini-css-extract-plugin
export var container = "_tp-0";
export var table = "_tp-2";
export var tableWrapper = "_tp-1";